export default class LeftNavigationController {
    constructor() {
        this.collapsed = false;
    }

    toggle() {
        this.collapsed = !this.collapsed;
        if (this.onToggle) {
            this.onToggle({
                isCollapsed: this.collapsed
            });
        }
    }

    get isCollapsed() {
        return this.collapsed;
    }
}



// WEBPACK FOOTER //
// ./app/common/navbar/left/left.controller.js